import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Tjyd extends React.PureComponent {
    state = {};
    static propTypes = {
        linkUrl: PropTypes.string,
    };

    static defaultProps = {
        linkUrl: '#',
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { linkUrl } = this.props;
        /**
         * 组件分发数据
         */

        return (
            <div className={styles.tjyd}>
                <span className={styles.shadow}>&gt;&gt;&gt;</span>
                <a href={linkUrl} target="_blank">
                    推荐阅读
                </a>
            </div>
        );
    }
}

export default errorBoundary(Tjyd);
